import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "query",
    "period",
    "form",
    "panel",
    "filterButton",
    "rangePill",
    "panelOpenInput",
  ]

  connect() {
    this.debounceTimer = null
  }

  disconnect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  }

  search() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => {
      this.submitForm()
    }, 150)
  }

  filter() {
    this.submitForm()
  }

  togglePanel() {
    if (!this.hasPanelTarget) return
    this.panelTarget.classList.toggle("hidden")
    const open = !this.panelTarget.classList.contains("hidden")
    if (this.hasFilterButtonTarget) {
      this.filterButtonTarget.dataset.open = open
    }
    // Hide the standalone range pill while the panel is open — the panel's
    // preset chips already reflect the active range.
    if (this.hasRangePillTarget) {
      this.rangePillTarget.classList.toggle("hidden", open)
    }
    if (this.hasPanelOpenInputTarget) {
      this.panelOpenInputTarget.value = open ? "1" : "0"
    }
  }

  openPanel() {
    if (!this.hasPanelTarget) return
    if (this.panelTarget.classList.contains("hidden")) {
      this.togglePanel()
    }
  }

  closePanel() {
    if (this.hasPanelTarget) this.panelTarget.classList.add("hidden")
    if (this.hasFilterButtonTarget)
      this.filterButtonTarget.dataset.open = "false"
    if (this.hasRangePillTarget) this.rangePillTarget.classList.remove("hidden")
    if (this.hasPanelOpenInputTarget) this.panelOpenInputTarget.value = "0"
    this.submitForm()
  }

  // Full filter reset — wipes every chip / toggle / range field. Same
  // semantics as the panel's Reset button. Reachable from the empty-state
  // "Reset filters" link inside the list.
  reset() {
    if (!this.hasFormTarget) return
    const form = this.formTarget
    form.querySelectorAll("input[type=checkbox]").forEach((el) => {
      el.checked = false
    })
    form.querySelectorAll("input[type=radio][value=all]").forEach((el) => {
      el.checked = true
    })
    form
      .querySelectorAll("input[name=range_start], input[name=range_end]")
      .forEach((el) => {
        el.value = ""
      })
    const calOpen = form.querySelector("input[name=calendar_open]")
    if (calOpen) calOpen.value = "0"
    this.submitForm()
  }

  submitForm() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
